import { Paper } from '@material-ui/core';

const GalleryImage = ({ image, index, onImageClick, t }) => {
  const altText = `${t(`gallery.filter.${image.category}`)} ${index + 1}`;

  return (
    <Paper
      className="overflow-hidden transition-all duration-300 hover:shadow-xl cursor-pointer group"
      elevation={2}
      onClick={() => onImageClick(image, index)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onImageClick(image, index);
        }
      }}
      role="button"
      tabIndex={0}
      aria-label={t('gallery.openImage', { alt: altText })}
    >
      <div className="relative aspect-square overflow-hidden bg-stone-200">
        <img
          src={image.src}
          alt={altText}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-20 transition-opacity duration-300" />
      </div>
    </Paper>
  );
};

export default GalleryImage;
